import { CoursePaymentType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { COURSE_PAYMENTS } from "../../utils/constants";

export const createCoursePayment = async (data: CoursePaymentType) =>
  await post<CoursePaymentType, string>(COURSE_PAYMENTS, data);

export const updateCoursePayment = async (data: CoursePaymentType) =>
  await put<CoursePaymentType, string>(COURSE_PAYMENTS, data);

export const getCoursePayments = async (data?: PagedRequestType) => {
  const queryParams = new URLSearchParams({
    PageNumber: data?.PageNumber?.toString() || "1",
    PageSize: data?.PageSize?.toString() || "100",
    IdCourse: data?.IdCourse || "",
    Regime: data?.Regime?.toString() || "",    
    ...(data?.IsToDebtsGenerateAutomatically ? { IsToDebtsGenerateAutomatically: `${data.IsToDebtsGenerateAutomatically}` } : {}),

  });


  const url = `${COURSE_PAYMENTS}?${queryParams.toString()}`;
  return await get<PagedResultsType<CoursePaymentType>>(url);
};
